import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  patchState,
  signalStore,
  withMethods,
  withState,
} from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { tapResponse } from '@ngrx/operators';
import { pipe, switchMap, tap } from 'rxjs';
import {
  setPropError,
  setPropInit,
  setPropLoaded,
  setPropLoading,
  withReqState,
} from '@application/data-access';
import { DeviceLoginService } from './infra/device-login.service';

export interface DeviceActivationState {
  approved: boolean;
}

const INITIAL_STATE: DeviceActivationState = {
  approved: false,
};

function normalizeActivationCode(raw: string): string {
  return raw.replace(/[-\s]/g, '').toUpperCase();
}

export const DeviceActivationStore = signalStore(
  { providedIn: 'root' },
  withState<DeviceActivationState>(INITIAL_STATE),
  withReqState('approve'),
  withMethods((
    store,
    deviceLoginService = inject(DeviceLoginService),
  ) => {
    const approve = rxMethod<string>(
      pipe(
        tap(() => patchState(store, setPropLoading('approve'))),
        switchMap((raw) =>
          deviceLoginService.approve(normalizeActivationCode(raw)).pipe(
            tapResponse({
              next: () =>
                patchState(store, {
                  approved: true,
                  ...setPropLoaded('approve'),
                }),
              error: (error: HttpErrorResponse) => {
                patchState(store, {
                  approved: false,
                  ...setPropError('approve', error),
                });
              },
            }),
          ),
        ),
      ),
    );

    return {
      approve,
      reset(): void {
        patchState(store, INITIAL_STATE, setPropInit('approve'));
      },
    };
  }),
);
